const $$splitComponentImporter = () => import('/src/src/routes/(compatibility)/regions.$regionId.news.$type.$postId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
/**
 * Redirect legacy news routes to new post routes (on region) for backward compatibility, including:
 * - /regions/:region_id/news/messages/:item_id
 * - /regions/:region_id/news/news_links/:item_id
 * - /regions/:region_id/news/social_links/:item_id
 *
 * @deprecated
 */
export const Route = createFileRoute("/(compatibility)/regions/$regionId/news/$type/$postId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});